import Amount from '../domain/Amount';
import Product from '../domain/Product';
import percentage from './percentage';
import formatDiscount from './formatDiscount';
import t from 'tcomb';

export default function animatePrice(from, to, product) {
  to = from - to //0.1
  from = 0  // 0
  t.assert(t.maybe(Amount).is(from));
  t.assert(Amount.is(to));
  t.assert(Product.is(product));

  let timeout;
  
  //const duration = 25;
  //const rate = 5;
  // const duration = 2000;
  // const rate = 300;
  const duration = 50;
  const rate = 10;
  const durationFadeIn = 700;
  let $price = $('#console #price');
  let $discount = $('#console #discount');
  let $do_reduce = $('#console #do_reduce');
  let $timeago = $('#console .clock');
  let _t = 0;
  let aumento_rate = duration / rate // 5
  let aumento = 0 + to  // 5
  let aumento_valore = aumento / aumento_rate // 1

  let next_price = function(_t) {
    let v =  _t * aumento_valore  / rate

    return v
  };

  const go = function(rate) {
    timeout = setTimeout(function() {
      _t += aumento_rate;
      let list_price_calculated = product.list_price //25
      let runtime_price_calculated = product.runtime.price 
      let price_calculated = list_price_calculated - runtime_price_calculated
      
      // da testare il seguente
      $price.html(product.format_amount(product.locale, next_price(_t)))
      // corretto senza animazione
      // $price.html(product.format_amount(product.locale, price_calculated))
      if (_t < duration) {
        go(_t);
      } else {
        // $discount.html(formatDiscount(product.locale, percentage(product.list_price, to))).css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
        $discount.html("Cash out or buy at " + product.format_amount(product.locale, runtime_price_calculated)).css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
        $do_reduce.css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
        $timeago.css('visibility', 'visible').hide().fadeTo(durationFadeIn, 1);
      }
    }, rate);
  };

  if (!t.Nil.is(from)) {
    // se il prezzo non è cambiato, animazione per il goodfellow
    if (from === to) {
      $price.hide().fadeTo(durationFadeIn, 1);
      $discount.hide().fadeTo(durationFadeIn, 1);
      $do_reduce.hide().fadeTo(durationFadeIn, 1);
    } else {
      $discount.css('visibility', 'hidden');
      $do_reduce.css('visibility', 'hidden');
      $timeago.css('visibility', 'hidden');
      go(rate);
      return timeout;
    }
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/animatePrice.js
 **/